var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Banner"},[_c('div',{staticClass:"Banner_content"},[_c('div',{staticClass:"Banner_content_test"},[_c('p',{class:[_vm.language == 'zh'?'zhFamilytitle':'enfamilytitle']},[_vm._v(_vm._s(_vm.$t('NewList.New')))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }